// id strings for messages/studio.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studio: Dict = {
  "studio.title.none": "Bikin cover",
  "studio.title.one": "Bikin {name} bernyanyi",
  "studio.title.many": "Bikin mereka bernyanyi",
  "studio.section.voice": "Suara",
  "studio.section.whoSings": "Siapa yang nyanyi",
  "studio.section.count": "{n} dari {max}",
  "studio.section.audio": "Audio",
  "studio.pickVoice": "Pilih suara",
  "studio.pickVoiceNote": "Pilih dari 100.000+ suara, atau suaramu sendiri",
  "studio.addVoice": "Tambah suara",
  "studio.whoSingsWhen": "Siapa nyanyi kapan",
  "studio.sound": "Suara",
  "studio.video": "Video",
  "studio.video.off": "Adu suara-suaramu di Marble Run",
  "studio.video.on": "Marble Run · 1 koin",
  "studio.video.add": "Tambah Marble Run · 1 koin",
  "studio.coins.unlimited": "Koin tanpa batas di Power",
  "studio.coins.one": "Sisa {count} koin",
  "studio.coins.other": "Sisa {count} koin",
  "studio.done": "Selesai",
  "studio.remove": "Hapus",
  "studio.cta.pickVoice": "Pilih suara dulu",
  "studio.cta.addAudio": "Tambah audio",
  "studio.cta.create": "Buat cover",
  "studio.auth.video": "Daftar untuk bikin video",
  "studio.auth.audio": "Daftar untuk pakai audiomu",
  "studio.auth.save": "Simpan cover-mu",
  "studio.upgrade.marbleRun": "Upgrade ke Creator untuk bikin video Marble Run",
  "studio.creatorReady": "Kamu sudah pakai Creator. Pilih Marble Run-mu.",
  "studio.maxVoices": "Kamu bisa memilih maksimal {max} suara.",
  "studio.alreadyIn": "{name} sudah ada di cover ini.",

  "studio.voices.search": "Cari suara",
  "studio.voices.clear": "Hapus pencarian",
  "studio.voices.trending": "Trending",
  "studio.voices.recent": "Baru dipakai",
  "studio.voices.mine": "Suaraku",
  "studio.voices.music": "Musik",
  "studio.voices.cartoon": "Kartun",
  "studio.voices.gaming": "Gaming",
  "studio.voices.anime": "Anime",
  "studio.voices.publicFigure": "Tokoh publik",
  "studio.voices.oftenWith": "Sering bareng {name}",
  "studio.voices.pairedWith": "Sering dipasangkan dengan {name}",
  "studio.voices.add": "Tambah {name}",
  "studio.voices.change": "Ganti {name}",
  "studio.voices.removeName": "Hapus {name}",
  "studio.voices.upTo": "Maksimal {max}",
  "studio.voices.makeDuet": "Jadikan duet",
  "studio.voices.uses": "{n} kali dipakai",
  "studio.voices.noMatch": "Tidak ada suara yang cocok dengan pencarian itu.",
  "studio.voices.noMine": "Kamu belum punya suara yang dilatih.",
  "studio.voices.noPairs":
    "Belum ada duet dengan suara ini minggu ini. Coba Trending.",
  "studio.empty": "Belum ada apa-apa di sini.",
  "studio.change": "Ganti",

  "studio.who.auto": "Pilih otomatis",
  "studio.who.manual": "Pilih sendiri",
  "studio.who.chose.one": "Pilihanmu · {n} bagian",
  "studio.who.chose.other": "Pilihanmu · {n} bagian",
  "studio.who.autoExplain":
    "Suara-suaranya bergantian setiap kali nyanyiannya berganti.",
  "studio.who.autoCanChoose":
    "Mau ikut atur? Dengan Pilih sendiri, kamu bisa pilih siapa yang nyanyi tiap bagian.",
  "studio.who.autoNeedsFile":
    "Untuk pilih sendiri, kamu perlu audio yang diunggah, rekaman, atau lagu dari library.",
  "studio.who.loading": "Memuat lagu…",
  "studio.who.failed":
    "Lagu ini tidak bisa diputar di sini, jadi Jammable yang akan menentukan.",
  "studio.who.pause": "Jeda",
  "studio.who.playSong": "Putar lagu",
  "studio.who.partLabel": "{name}, {start} sampai {end}",
  "studio.who.moveSwap": "Geser titik pergantian suara",
  "studio.who.part": "Bagian {n}",
  "studio.who.play": "Putar",
  "studio.who.split": "Pisah",
  "studio.who.takeOver": "Siapa yang ambil alih bagian ini?",
  "studio.who.before": "Bagian sebelumnya",
  "studio.who.after": "Bagian sesudahnya",
  "studio.who.sungBy": "Dinyanyikan oleh",
  "studio.who.hint":
    "Ketuk satu bagian untuk mendengarnya dan memilih siapa yang menyanyikannya. Seret pegangan putih untuk menggeser titik pergantian suara.",
  "studio.who.tooShort": "Tiap bagian minimal {secs} detik.",

  "studio.song.upload": "Unggah",
  "studio.song.library": "Library",
  "studio.song.tts": "Ketik teks",
  "studio.song.generate": "Lagu AI",
  "studio.song.mic": "Rekam",
  "studio.song.sources": "Sumber lagunya",
  "studio.song.rights":
    "Unggah hanya audio yang kamu punya hak untuk memakainya.",
  "studio.song.search": "Cari lagu",
  "studio.song.searchUploads": "Cari di unggahanmu",
  "studio.song.searchLibrary": "Cari di library lagu",
  "studio.song.popular": "Populer",
  "studio.song.yourUploads": "Unggahanmu",
  "studio.song.noMatch": "Tidak ada lagu yang cocok dengan pencarian itu.",
  "studio.song.noUploads": "Kamu belum mengunggah apa pun.",
  "studio.song.picked": "Dipilih",
  "studio.source.generate": "Dibuat AI",
  "studio.source.upload": "Diunggah",
  "studio.source.library": "Dari Library",
  "studio.source.mic": "Direkam",
  "studio.source.tts": "Teks ke Suara",

  "studio.tts.what": "Mereka harus bilang apa?",
  "studio.tts.placeholder": "Ketik apa yang harus mereka ucapkan...",
  "studio.tts.baseVoice": "SUARA DASAR",
  "studio.tts.accent": "AKSEN",
  "studio.tts.delivery": "GAYA BICARA",
  "studio.tts.use": "Pakai teks ini",
  "studio.tts.empty": "Masukkan teks dulu.",
  "studio.tts.tooLong": "Teks melebihi batas maksimal {max} karakter.",
  "studio.tts.gender.female": "Perempuan",
  "studio.tts.gender.male": "Laki-laki",
  "studio.tts.accent.US": "Amerika",
  "studio.tts.accent.GB": "Inggris",
  "studio.tts.accent.FR": "Prancis",
  "studio.tts.accent.DE": "Jerman",
  "studio.tts.accent.ES": "Spanyol",
  "studio.tts.accent.IT": "Italia",
  "studio.tts.accent.KR": "Korea",
  "studio.tts.accent.AU": "Australia",
  "studio.tts.accent.JP": "Jepang",
  "studio.tts.expr.default": "Normal",
  "studio.tts.expr.whispered": "Berbisik",
  "studio.tts.expr.happy": "Senang",
  "studio.tts.expr.sad": "Sedih",
  "studio.tts.expr.angry": "Marah",
  "studio.tts.expr.shouting": "Berteriak",
  "studio.tts.expr.terrified": "Ketakutan",

  "studio.ai.style": "PILIH GAYA, ATAU JELASKAN SENDIRI",
  "studio.ai.styleLabel": "Gaya lagu",
  "studio.ai.stylePlaceholder":
    "mis. pop musim panas yang ceria, gitar akustik, reff yang catchy",
  "studio.ai.lyrics": "Lirik",
  "studio.ai.lyricsPlaceholder":
    "Kosongkan supaya AI yang menulis liriknya, atau:\n\n[Verse 1]\nKetik liriknya di sini...\n\n[Chorus]\nPakai tag [Verse], [Chorus], [Bridge] untuk memberi struktur",
  "studio.ai.ownLyrics": "+ Tulis lirik sendiri (kalau tidak, AI yang menulis)",
  "studio.ai.use": "Pakai lagu ini",
  "studio.ai.noStyle": "Jelaskan gaya lagunya.",
  "studio.ai.styleTooLong": "Deskripsi gaya harus kurang dari {max} karakter.",
  "studio.ai.lyricsTooLong": "Lirik harus kurang dari {max} karakter.",
  "studio.ai.genre.pop": "Pop",
  "studio.ai.genre.trap": "Trap",
  "studio.ai.genre.rnb": "R&B",
  "studio.ai.genre.indie": "Indie",
  "studio.ai.genre.kpop": "K-pop",
  "studio.ai.genre.edm": "EDM",
  "studio.ai.genre.lofi": "Lo-fi",
  "studio.ai.genre.country": "Country",
  "studio.seo.title": "Buat cover AI | Jammable",
  "studio.seo.description":
    "Pilih suara, tambahkan audio yang kamu punya hak untuk memakainya, dan buat cover AI di Jammable.",
};

export default studio;
